// extracted by mini-css-extract-plugin
export default {"overviewCaption":"approve-tab-mobile_overviewCaption__Iwk7l","footerSection":"approve-tab-mobile_footerSection__aTyYF"};